module.exports = __webpack_public_path__ + "static/media/ta-pro-01.e1d6e557.png";